// Uploaded files (syllabus, prospectus, application documents) are stored as base64
// data: URLs in MongoDB. Browsers BLOCK top-frame navigation to data: URLs, so an
// <a href="data:..." target="_blank"> silently does nothing. Converting to a Blob URL
// makes the file viewable (and printable) in a new tab and downloadable.

function dataUrlToBlob(dataUrl) {
  const [head, b64] = dataUrl.split(",");
  const mime = (head.match(/:(.*?);/) || [])[1] || "application/octet-stream";
  const bin = atob(b64);
  let n = bin.length;
  const u8 = new Uint8Array(n);
  while (n--) u8[n] = bin.charCodeAt(n);
  return new Blob([u8], { type: mime });
}

function toObjectUrl(file) {
  return file.startsWith("data:") ? URL.createObjectURL(dataUrlToBlob(file)) : file;
}

// Open the file in a new tab. Returns false if a popup blocker prevented it.
export function viewDataUrl(file) {
  if (!file) return false;
  const url = toObjectUrl(file);
  const w = window.open(url, "_blank");
  if (url.startsWith("blob:")) setTimeout(() => URL.revokeObjectURL(url), 60000);
  return !!w;
}

// Trigger a download of the file with the given filename.
export function downloadDataUrl(file, filename = "download") {
  if (!file) return;
  const url = toObjectUrl(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  if (!url.startsWith("blob:")) a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
  if (url.startsWith("blob:")) setTimeout(() => URL.revokeObjectURL(url), 60000);
}
